enum URLParams {
  TOKEN = 'token',
  REDIRECT_URI = 'redirect_uri',
  STATE = 'state',
  PROVIDER = 'provider',
  CODE = 'code',
}

export default URLParams;
